import { useEffect, useState } from 'react';

/**
 * Cycle through a list of cameras on a fixed interval.
 *
 * @param cameraCount How many cameras are available to show.
 * @param rotationSeconds How long each camera stays on screen.
 * @returns The index to display and the index to warm up next. They are equal when there is
 *   nothing to rotate to, in which case no timer runs.
 */
export function useFeedRotation(
  cameraCount: number,
  rotationSeconds: number,
): { activeIndex: number; nextIndex: number } {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (cameraCount < 2) return;

    const id = setInterval(() => setTick((t) => t + 1), rotationSeconds * 1000);
    return () => clearInterval(id);
  }, [cameraCount, rotationSeconds]);

  if (cameraCount < 1) return { activeIndex: 0, nextIndex: 0 };

  const activeIndex = tick % cameraCount;
  return { activeIndex, nextIndex: (activeIndex + 1) % cameraCount };
}
